import { Injectable } from '@angular/core';
import { AngularFireDatabase, AngularFireList, AngularFireObject, AngularFireAction } from 'angularfire2/database';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import  'rxjs/add/operator/take';
import 'rxjs/add/operator/switchMap';

import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';

import { CaseData } from './case-data';
import { refCount } from 'rxjs/operators/refCount';

@Injectable()
export class FireDataService {

  // this params must be read from db for given domain (of user login) <-------------------------
  currentYear = 2018;
  selectedSite = 'Via Rielta';
  activeSchedule = 'C::2018-09-24';
  activeScheduleSupport = 'S::2018-09-24';
  stdTime = ['08:10','09:05','10:00','11:10','12:05','12:55','13:45','14:35','15:25','16:15'] 

  //root and path to define db model
  dbRoot = '/mySchool/domains/liceoguggenheim+gov+it/';
  pathClasses ='classes/';
  pathRooms = 'rooms/';
  pathTeachers = 'teachers/';
  pathWeekly = 'weekly/';
  pathActiveSchedule = 'schedule/' + this.activeSchedule + '/';
  pathActiveScheduleSupport = 'schedule/' + this.activeScheduleSupport + '/';
  pathUser = 'users/';
  pathSite = this.selectedSite + '/';   
  pathCases = 'cases/' + this.currentYear + '/' + this.selectedSite + '/';  
  pathAvailbility = 'availability-at-a-charge/'; 
  pathRecovery = 'absences-to-be-recovered/'; 
  pathSupportSchedule = "support-schedule/";
  weekDays = ['LUN', 'MAR', 'MER', 'GIO', 'VEN', 'SAB', 'DOM'];  
  classesOutOfSchool = [];  // one row for every teacher out of school with a group
  add60gg = 60*24*60*60*1000;
  MAX_KEY = 100000000000000; // used to have key right in DESC order

  //items: FirebaseListObservable<any[]>;
  item: Observable<any>;
  days: Observable<any>;
  //caseData: Observable<AngularFireAction<firebase.database.DataSnapshot>[]>;
  caseData: Observable<{}[]>;
  caseId$: BehaviorSubject<string|null>;
  teacherLack: Observable<any>;
  user: Observable<firebase.User>;
  
  //searchTeacher: Observable<AngularFireAction<firebase.database.DataSnapshot>[]>;
  listTeacherC: any;
  listTeacherS: any;
  termTeacher: BehaviorSubject<string|null>;
  listGroup: any;
  
  constructor(public db: AngularFireDatabase, public afAuth: AngularFireAuth) {

    this.user = afAuth.authState;
    //this.dbAuth = afAuth
    this.caseId$ = new BehaviorSubject(null);
    this.caseData = this.caseId$.switchMap(caseId =>
        db.list(this.dbRoot + this.pathCases + 'regDate/', ref => 
        caseId ? ref.orderByChild('caseId').equalTo(caseId).limitToFirst(100) : ref
        ).valueChanges()
    );
 
    this.teacherLack = db.list(this.dbRoot + this.pathCases + 'endDate/' , ref => ref.orderByChild('firstTeacher')).valueChanges();

    this.listGroup = db.list(this.dbRoot + this.pathActiveSchedule + this.pathClasses + this.selectedSite , 
      ref => ref.orderByKey().startAt('0000000000000')).snapshotChanges();

    this.termTeacher = new BehaviorSubject(null);
    this.listTeacherC = this.termTeacher.switchMap(teacher =>
      db.list(this.dbRoot+this.pathActiveSchedule+this.pathTeachers+this.pathSite, ref =>
        teacher ? ref.orderByKey().startAt(teacher).endAt(teacher+'zzzzzzzzzzzzz') : ref
      ).snapshotChanges()
    );
    this.listTeacherS = this.termTeacher.switchMap(teacher =>
      db.list(this.dbRoot+this.pathActiveScheduleSupport+this.pathTeachers+this.pathSite, ref =>
        teacher ? ref.orderByKey().startAt(teacher).endAt(teacher+'zzzzzzzzzzzzz') : ref
      ).snapshotChanges()
    );

  }
  
  public getGroupList () {
    return new Promise((resolve) => {
      this.listGroup
      .subscribe(res => {
        var groups = []
        for (var i in res) {
          groups.push(res[i].key)
        }
        resolve (groups)
      }) 
    }); 
  }

  public getCaseData (caseId) {
    this.caseId$.next(caseId)
    return  this.caseData 
  }

  public searchTeacher(type, teacher) {
    if (type == 'C') {
      this.termTeacher.next(teacher);
      return this.listTeacherC
    }
    if (type == 'S') {
      this.termTeacher.next(teacher);
      return this.listTeacherS
    }
  }

  //-------------------------------------------------------
  // return an array of teacher that lacks in the given date
  // the array contains schedule info for every teacher
  //-------------------------------------------------------
  public getTeacherLack (reqDate, table, fillRow, no1, no2, no3) {  //  no1,no2,no3  will be managed !!!!!!!!!!!!!
    var path = this.dbRoot + this.pathActiveSchedule + this.pathTeachers + this.pathSite;
    var self = this
    var row = this.copyArray(fillRow);
    var fillColor = '#ffe8e2';
    for (var i in row) {row[i].color = fillColor}
    var sectionFill = {'type': '', 'day': '', 'teacher': '','startDate': '', 'endDate': ''}
    row[0].text = sectionFill, row[0].text.teacher = '*** Assenze docenti e classi ***', row[0].text.type = 'AH';  // means: A=Assenti, H=Header
    table.push(row);
    return new Promise((resolve) => {
      this.teacherLack.subscribe(snapshot => {
        var promises = [], keySched, icon;
        self.classesOutOfSchool = [];    // serve per trovare gli insegnanti che si liberano perchè la loro clesse è in uscita didattica
        snapshot.forEach(lack => {
          icon = ''
          if (lack.startDate <= reqDate && lack.endDate >= reqDate ) {
            if (lack.caseId == 15 || lack.caseType == 'S') {
              icon = 'outOfSchool'                        // Uscita didattica, se non tutto il giorno riporta le singole ore (solo se di un giorno)
              if (lack.startDate == reqDate) {
                if (lack.settled !== true) {
                self.classesOutOfSchool.push(lack.classes);
                promises.push(self.pushTeacherClassOut('A', lack.firstTeacher, reqDate, fillRow, lack.startDate, lack.endDate, fillColor, '', lack.classes, icon));
                } 
              }
              if (lack.startDate !== reqDate || lack.settled == true) {
                promises.push(self.getClassOut('A', lack.firstTeacher, reqDate, fillRow, lack.startDate, lack.endDate, fillColor, '', icon));
              }
            } else { //start case not 15
              if(lack.caseId == 16) { icon = 'outOfSchool' }
              if (lack.startDate == reqDate) {
                if (lack.settled !== true) {
                promises.push(self.pushTeacherClassOut('A', lack.firstTeacher, reqDate, fillRow, lack.startDate, lack.endDate, fillColor, lack.note, lack.classes, icon));
                } 
              }
              if (lack.startDate !== reqDate || lack.settled == true) {
                promises.push(self.getTeacherClass('A', lack.firstTeacher, reqDate, fillRow, lack.startDate, lack.endDate, fillColor, lack.note, icon))
              }
            } // end case non 15
          }
        });
        Promise.all(promises)
        .then((results) => {
          function markClass (row) {
            function findSched(el) {
              return el == keySched
            }
            for (var i in self.classesOutOfSchool) {
              //for (var j in self.classesOutOfSchool[i]) {
                for (var keySched in self.classesOutOfSchool[i]) {
                  if (row[(self.stdTime.findIndex(findSched))+1]['text']['group'] == self.classesOutOfSchool[i][keySched]) {
                    //row[(self.stdTime.findIndex(findSched))+1]['text']['outOfSchool'] = true
                  }
                }
              //}
            }
          }
          for (var item in results) {
            markClass (results[item]);
            if (results[item][0].text.teacher.substr(0,1) !== 'E') {table.push(results[item])}
          }
          return self.getTeachersReplacement('S', reqDate, fillRow)
        })
        .then(res => {
        var resClear = this.copyArray(res); 
        if (Object.keys(resClear).length > 0) {
            var row = this.copyArray(fillRow);
            for (var i in row) {row[i].color = '#fffcdc'}
            row[0].text = Object.assign({}, sectionFill), row[0].text.teacher = '*** Sostituzioni e Uscite Classe ***', row[0].text.type = 'SH'; // S=Sostituzioni
            table.push(this.copyArray(row));
            row[0].text = Object.assign({}, sectionFill), row[0].text.teacher = 'EC,DC,UC', row[0].text.type = 'SHC'; // Uscita classe
            table.push(row);
            for (var item in resClear) {
              table.push(self.copyArray(resClear[item]));
            }
          }
          return self.getTeacherForRecover('R',reqDate, fillRow)
        })
        .then(res => {
          var resClear = this.clearDuplicate(res, table);
          //var resClear = this.copyArray(res);  
          if (Object.keys(resClear).length > 0) {
            //console.log("Found class...:", resClear)
            var row = this.copyArray(fillRow);
            row[0].text = Object.assign({}, sectionFill), row[0].text.teacher = '*** Recupero permessi ***', row[0].text.type = 'RH'; // R=Recupero, H=header
            table.push(row);
            for (var item in resClear) {
              table.push(self.copyArray(resClear[item]));
            }
          } 
          return  self.getTeacherDispo('D', 'C', '--C--', reqDate, table, fillRow, [])
        }) 
        .then(res => {
          var resClear = this.copyArray(res); 
          return  self.getTeacherDispo('D', 'S', '--C--', reqDate, table, fillRow, resClear)
        })
        .then(res => {
          var resClear = this.copyArray(res); 
          return  self.getTeacherDispoGroupOutOfSchool('D', '  D  ', reqDate, table, fillRow, resClear)
        })  
        .then(res => {
          var resClear = this.clearDuplicate(res, table);  // must manage better techer duplication
          //var resClear = this.copyArray(res); 
          if (Object.keys(resClear).length > 0) {
              var row = this.copyArray(fillRow);
              row[0].text = Object.assign({}, sectionFill), row[0].text.teacher = '*** Disponibilità ***', row[0].text.type = 'DH'; // D=Disponibili
              table.push(row);
              for (var item in resClear) {
                table.push(self.copyArray(resClear[item]));
              }
            }
            return self.getTeacherDispoAtACharge('P', '- P -', reqDate, table, fillRow)
        })
        .then(res => {
          var resClear = this.copyArray(res);
          if (Object.keys(resClear).length > 0) {
            var row = this.copyArray(fillRow);
            row[0].text = Object.assign({}, sectionFill), row[0].text.teacher = '*** Disponibilità a Pag. ***', row[0].text.type = 'PH'; // P=Pagamento, H=header
            table.push(row);
            for (var item in resClear) {
              table.push(self.copyArray(resClear[item]));
            }
          }
          return self.getTeacherSupport('T',reqDate, fillRow)
        })
        .then(res => {
          var resClear = this.copyArray(res);  //this.clearDuplicate(res, table);
          if (Object.keys(resClear).length > 0) {
            //console.log("Found class...:", resClear)
            var row = this.copyArray(fillRow);
            row[0].text = Object.assign({}, sectionFill), row[0].text.teacher = '*** Sostegno ***', row[0].text.type = 'TH'; // T=Sostegno, H=header
            table.push(row);
            for (var item in resClear) {
              table.push(self.copyArray(resClear[item]));
            }
          }
            resolve();
        });
      });
    });
  }
  //-------------------------------------------------------
  // return an array with the schedule from the case 15 
  // for the day not equal startDate
  //-------------------------------------------------------
  private getClassOut(type, teacher, reqDate, fillRow, startDate, endDate, fillColor, note, icon) {
    return new Promise((resolve) => { 
     var self = this
     self.getClass(teacher.substr(3), reqDate)
     .then(res =>{
       var allTimeClass = {}
       for (var i in res) {
         allTimeClass[res[i].schedule] = res[i].group
       }
       self.classesOutOfSchool.push(allTimeClass);
       resolve (self.pushTeacherClassOut('A', teacher, reqDate, fillRow, startDate, endDate, fillColor, '', allTimeClass, icon))
     })
    });
   }
  //-------------------------------------------------------
  // return an array with the schedule from the case 15 
  // for the given teacher
  //-------------------------------------------------------
  private pushTeacherClassOut(type, teacher, reqDate, fillRow, startDate, endDate, fillColor, note, item, icon) {
    return new Promise((resolve) => { 
     var self = this
       //var d = new Date(reqDate);   
       //var dayName = this.weekDays[d.getDay()-1];
       var dayKey = this.getDayKey(reqDate)
       var teacherSchedule = this.copyArray(fillRow);
       for (var i in teacherSchedule) {teacherSchedule[i].color = fillColor} 
       teacherSchedule[0].text = 
       {'type': type, 'day': dayKey, 'teacher': teacher, 'startDate': startDate, 'endDate': endDate, 'note': note, 'icon': icon};
          var keySched, course, outOfSchool, group;
          function findSched(el) {
            return el == keySched
          }
          for (keySched in item) {
            course = '', group = item[keySched]
            if (item[keySched] == 'Ric') {group = '--C--', course = 'Ric'}
            if (item[keySched] == true) {group= '', course = '', outOfSchool = true}
            if (item[keySched] == teacher.substr(3)) {group = '', course = ''}
            teacherSchedule[self.stdTime.findIndex(findSched)+1].text = 
                {'group': group, 'course': course, 'room': '', 'icon': ''}
          }
          resolve(teacherSchedule)
       });
   }
  //-------------------------------------------------------
  // return an array with the schedule for the given teacher
  // in the given day (of week)
  //-------------------------------------------------------
  private getTeacherClass(type, teacher, reqDate,fillRow, startDate, endDate, fillColor, note, icon) {
   return new Promise((resolve) => { 
    var self = this
    var pathActive = this.pathActiveSchedule
    if (teacher.substr(0,1) == 'S') {pathActive = this.pathActiveScheduleSupport}
      var path = this.dbRoot + pathActive + this.pathTeachers + this.pathSite
      //var d = new Date(reqDate);   
      //var dayName = this.weekDays[d.getDay()-1];
      var dayKey = this.getDayKey(reqDate)
      var teacherSchedule = this.copyArray(fillRow);
      for (var i in teacherSchedule) {teacherSchedule[i].color = fillColor} 
      teacherSchedule[0].text = 
      {'type': type, 'day': dayKey, 'teacher': teacher, 'startDate': startDate, 'endDate': endDate, 'note': note, 'icon': icon};
      this.db.object(path + teacher.substr(3) +'/'+dayKey, ).valueChanges()
      .subscribe(item => {
          var keySub, keySched, keyGroup;
          function findSched(el) {
            return el == keySched
          }
          for (keySub in item) {
              for (keySched in item[keySub]) {
                  for (keyGroup in item[keySub][keySched]) {
                    var subKey = keySub
                    if (subKey == 'R') {subKey = 'Ric'}
                    teacherSchedule[self.stdTime.findIndex(findSched)+1].text = 
                    {'group': keyGroup, 'course': subKey, 'room': item[keySub][keySched][keyGroup].room, 'icon': ''}
                  }
              }
          }
           resolve(teacherSchedule)
        });
      });
  }
  //-------------------------------------------------------
  // return an array with the scheduled teacher's replacement
  // in the given day (of week)
  //-------------------------------------------------------
  private getTeachersReplacement(type,reqDate,fillRow) {
    return new Promise((resolve) => { 
     var self = this
     var path = this.dbRoot + this.pathCases;
       //var d = new Date(reqDate);   
       //var dayName = this.weekDays[d.getDay()-1];
       var dayKey = this.getDayKey(reqDate)
       //var dateString = new Date(reqDate).toString();
       var teacherSchedule = [];
       var teacherScheduleRow = this.copyArray(fillRow);
       for (var i in teacherScheduleRow) {teacherScheduleRow[i].color = '#fffcdc'}   //verdino = #f3ffd5, giallino = #fffcdc, cipria = #ffe8e2
       teacherScheduleRow[0].text = {'type': type, 'day': dayKey, 'teacher': '', 'startDate': '', 'endDate': ''};
          this.db.list(path + 'regDate/', ref => ref.orderByChild('caseId').equalTo(51)).valueChanges()
            .subscribe(items  => {
                //var dateString = new Date(reqDate).toString();
                var keyCase, keyClass, keySched, keyTeacher, keyRegDate;
                function findSchedule(el) {
                  return el == keySched
                }
                for (keyCase in items ) {
                  if (items[keyCase]['startDate'] == reqDate) {
                    keyTeacher = items[keyCase]['firstTeacher']
                    keyRegDate = items[keyCase]['regDate']
                      for (keySched in items[keyCase]['classes']) {
                        var group = items[keyCase]['classes'][keySched]
                        var iTeach = -1;
                        var i = -1;
                        for (var item in teacherSchedule) {
                          i++;
                          if (teacherSchedule[item][0].text.teacher == keyTeacher) {
                            iTeach = i;
                            teacherSchedule[iTeach][0].regArray.push(keyRegDate);
                          }
                        }
                        if (iTeach == -1) {
                            teacherSchedule.push(self.copyArray(teacherScheduleRow));
                            iTeach = teacherSchedule.length - 1;
                            teacherSchedule[iTeach][0].text.teacher = keyTeacher, teacherSchedule[iTeach][0].regArray.push(keyRegDate);
                        }
                        teacherSchedule[iTeach][self.stdTime.findIndex(findSchedule)+1].text = 
                              {'group': group, 'course': '', 'room': ''}
                      }
                    
                  }
                }
                teacherSchedule.sort(function (a, b) {
                  var nameA = a[0].text.teacher.toUpperCase(); // ignore upper and lowercase
                  var nameB = b[0].text.teacher.toUpperCase(); // ignore upper and lowercase
                  if (nameA < nameB) {return -1}
                  if (nameA > nameB) {return 1}
                  return 0;
                });
               resolve(teacherSchedule)
             });
       });
   }
  //-------------------------------------------------------
  // return an array with the scheduled teacher dispo
  // in the given day (of week)
  //-------------------------------------------------------
  private getTeacherDispo(type, teacherType, group, reqDate, table, fillRow, teacherSchedule) {
   return new Promise((resolve) => { 
    var self = this;
    var pathActive = this.pathActiveSchedule
    if (teacherType == 'S') {pathActive = this.pathActiveScheduleSupport}
      var path = this.dbRoot + pathActive + this.pathClasses + this.pathSite
      //var d = new Date(reqDate);   
      //var dayName = this.weekDays[d.getDay()-1];
      var dayKey = this.getDayKey(reqDate)
      var teacherScheduleRow = this.copyArray(fillRow);
      teacherScheduleRow[0].text = {'type': type, 'day': dayKey, 'teacher': '','startDate': '', 'endDate': ''};
        this.db.object(path + group +'/'+dayKey, ).valueChanges()
          .subscribe(items => {
            var keySched, keyTeacher;
            function findSchedule(el) {
              return el == keySched
            }
            for (keySched in items) {
              for (keyTeacher in items[keySched]) {
                if (items[keySched][keyTeacher].subject == 'R') {items[keySched][keyTeacher].subject = 'Ric'}
                  var iTeach = -1;
                  var i = -1;
                  for (var item in teacherSchedule) {
                    i++;
                    if (teacherSchedule[item][0].text.teacher == teacherType + '::' + keyTeacher) {iTeach = i}
                  }
                  if (iTeach == -1) {
                      teacherSchedule.push(self.copyArray(teacherScheduleRow));
                      iTeach = teacherSchedule.length - 1;
                      teacherSchedule[iTeach][0].text.teacher = teacherType + '::' + keyTeacher
                  }
                  teacherSchedule[iTeach][self.stdTime.findIndex(findSchedule)+1].text = 
                        {'group': group, 'course': items[keySched][keyTeacher].subject, 'room': items[keySched][keyTeacher].room}
                
              }
            } 
            teacherSchedule.sort(function (a, b) {
              var nameA = a[0].text.teacher.toUpperCase(); // ignore upper and lowercase
              var nameB = b[0].text.teacher.toUpperCase(); // ignore upper and lowercase
              if (nameA < nameB) {return -1}
              if (nameA > nameB) {return 1}
              return 0;
            });
            resolve(teacherSchedule)
          });
      });
  }
    //-------------------------------------------------------
  // return an array with the scheduled teacher dispo
  // in the given day (of week)
  //-------------------------------------------------------
  private getTeacherDispoGroupOutOfSchool(type, group, reqDate, table, fillRow, teacherSchedule) {
    return new Promise((resolve) => { 
     var self = this
       var path = this.dbRoot + this.pathActiveSchedule + this.pathClasses + this.pathSite
      //var d = new Date(reqDate);   
      //var dayName = this.weekDays[d.getDay()-1];
      var dayKey = this.getDayKey(reqDate)
       var teacherScheduleRow = this.copyArray(fillRow);
       teacherScheduleRow[0].text = {'type': type, 'day': dayKey, 'teacher': '','startDate': '', 'endDate': ''};
       var promises = [];
        
        function findTeacher(keyClass, keySched) {
          function findSchedule(el) {
            return el == keySched
            }
          return new Promise((resolve) => { 
            self.db.object(path + keyClass +'/'+dayKey + '/' + keySched, ).valueChanges()
            .subscribe(items => {
              for (var keyTeacher in items) {
                 var iTeach = -1;
                 var i = -1;
                 for (var item in teacherSchedule) {
                   i++;
                   if (teacherSchedule[item][0].text.teacher == 'C::' + keyTeacher) {iTeach = i}
                 }
                 if (iTeach == -1) {
                     teacherSchedule.push(self.copyArray(teacherScheduleRow));
                     iTeach = teacherSchedule.length - 1;
                     teacherSchedule[iTeach][0].text.teacher = 'C::' + keyTeacher           // PAY ATTENTION!!! MUST BE DESIGN A BETTER SOLUTION
                 }
                 teacherSchedule[iTeach][self.stdTime.findIndex(findSchedule)+1].text = 
                       {'group': group, 'course': items[keyTeacher].subject, 'room': items[keyTeacher].room}
              }
              resolve();
            });
          });
        }
        for (var i in self.classesOutOfSchool) {
          for (var keySched in self.classesOutOfSchool[i]) {
            var keyClass = self.classesOutOfSchool[i][keySched];
            promises.push(findTeacher(keyClass, keySched));
          }
        }
        Promise.all(promises)
        .then((results) => {
          resolve(teacherSchedule)
        })
        .catch((e) => {
          console.log("Error rading class for teacher dispo with class out of school", e);
        });
    });
   }
  //-------------------------------------------------------
  // return an array with the scheduled teacher dispo
  // in the given day (of week) but only at a charge
  //-------------------------------------------------------
  private getTeacherDispoAtACharge(type,group, reqDate, table, fillRow) {
    return new Promise((resolve) => { 
      var self = this
      var path = this.dbRoot + this.pathCases + this.pathAvailbility + this.pathSite
      //var d = new Date(reqDate);   
      //var dayName = this.weekDays[d.getDay()-1];
      var dayKey = this.getDayKey(reqDate)
      var teacherSchedule = [];
      var teacherScheduleRow = this.copyArray(fillRow);
      teacherScheduleRow[0].text = {'type': type, 'day': dayKey, 'teacher': '','startDate': '', 'endDate': ''};
      this.db.object(path ).valueChanges()
      .subscribe(items => {
        var keyTeacher, keyEndDay, keyWeekDay, keyHourDispo
        function findSchedule(el) {
          return el == keyHourDispo
        }
        for (keyTeacher in items) {
          for (keyEndDay in items[keyTeacher]) {
            //console.log("FDS --> getTeacherDispoAtACharge --> 1 : ", items[keyTeacher])
            if (items[keyTeacher][keyEndDay]['endDate'] >= reqDate && items[keyTeacher][keyEndDay]['startDate'] <= reqDate  ) {
              //console.log("FDS --> getTeacherDispoAtACharge --> 2 : ", items[keyTeacher][keyEndDay])
              for (keyWeekDay in items[keyTeacher][keyEndDay]['schedule']) {
                if (keyWeekDay == dayKey) {
                  for (keyHourDispo in items[keyTeacher][keyEndDay]['schedule'][keyWeekDay]) {
                    var iTeach = -1;
                    var i = -1;
                    for (var item in teacherSchedule) {
                      i++;
                      if (teacherSchedule[item][0].text.teacher == keyTeacher) {iTeach = i}
                    }
                    if (iTeach == -1) {
                        teacherSchedule.push(self.copyArray(teacherScheduleRow));
                        iTeach = teacherSchedule.length - 1;
                        teacherSchedule[iTeach][0].text.teacher = keyTeacher                      // PAY ATTENTION!!! MUST BE DESIGN A BETTER SOLUTION
                        teacherSchedule[iTeach][0].text.startDate = items[keyTeacher][keyEndDay]['startDate']
                        teacherSchedule[iTeach][0].text.endDate = items[keyTeacher][keyEndDay]['endDate']
                    }
                    teacherSchedule[iTeach][self.stdTime.findIndex(findSchedule)+1].text = 
                          {'group': group, 'course': '', 'room': ''}
                  }
                }
              }
            }
          }
        }
        resolve(teacherSchedule)
      });
    });
  }
  //---------------------------------------------------------------
  // return an array with the teachers that must recover some hours 
  //---------------------------------------------------------------
  private getTeacherForRecover(type, reqDate, fillRow) {
    return new Promise((resolve) => { 
      var self = this
      var path = this.dbRoot + this.pathCases + this.pathRecovery
      var d = new Date(reqDate);   
      var dayName = this.weekDays[d.getDay()-1];
      var dayKey = d.getDay() + '-' + dayName;
      var fillColor = fillRow[0].color
      var fillRowRecover = this.copyArray(fillRow);
      for (var i=1; i<fillRowRecover.length; i++){
        fillRowRecover[i].text = {'group': '- R -', 'course': '', 'room': ''}
      }
        this.db.object(path , ).valueChanges()
          .subscribe(items => {
            var promises = [];
            var keyTeacher, keyEndDate;
            for (keyTeacher in items) {
              for (keyEndDate in items[keyTeacher]) {
                var endDate = keyEndDate.split('-')
                if (Number(endDate[0] >= reqDate)) {
                  var recoveredHours = 0, toRecover = 0;
                  if (items[keyTeacher][keyEndDate].regRecovery) {
                    recoveredHours = Object.keys(items[keyTeacher][keyEndDate].regRecovery).length
                  } 
                  if (items[keyTeacher][keyEndDate].classes) {
                    toRecover = Object.keys(items[keyTeacher][keyEndDate].classes).length
                  }
                  if (recoveredHours < toRecover) {
                    var endDate = keyEndDate.split('-')
                    let d = new Date(Number(endDate[0]));
                    var note = '(' + (toRecover - recoveredHours) +'h < ' + d.toLocaleDateString('it-IT', {day:'2-digit', month:'short'}) +')'
                    promises.push(  self.getTeacherClass(type, keyTeacher, reqDate, fillRowRecover, '', keyEndDate, fillColor, note, ''))
                  }
                }
              }
            } 
            Promise.all(promises)
            .then((results) => {
              resolve(results)
            })
            .catch((e) => {
              console.log("Error rading class for teacher recover", e);
            });
          });
       });
   }
    //-------------------------------------------------------
  // return an array with the schedule for the given teacher
  // in the given day (of week)
  //-------------------------------------------------------
  private getTeacherSupport(type, reqDate, fillRow) {
    return new Promise((resolve) => { 
      var self = this
      var path = this.dbRoot + this.pathActiveScheduleSupport + this.pathTeachers  + this.pathSite
      //var d = new Date(reqDate);   
      //var dayName = this.weekDays[d.getDay()-1];
      var dayKey = this.getDayKey(reqDate)
      var teacherSchedule = [];
      var teacherScheduleRow = this.copyArray(fillRow);
      teacherScheduleRow[0].text = {'type': type, 'day': dayKey, 'teacher': '','startDate': '', 'endDate': ''};
      //for (var i=1; i<teacherScheduleRow.length; i++){
      //  teacherScheduleRow[i].text = {'group': '- S -', 'course': '', 'room': ''}
      //}
      this.db.object(path ,).valueChanges()
          .subscribe(items => {
            var keyTeacher, keyDay, keyCourse, keyHourPresent, keyGroup;
            function findSchedule(el) {
              return el == keyHourPresent
            }
            for (keyTeacher in items) {
              for(keyDay in items[keyTeacher]) {
                if (keyDay == dayKey  ) {                // verificare, deve includere anche il giorno stesso di inizio attività, ora non lo fa
                  for(keyCourse in items[keyTeacher][keyDay]) {

                      for (keyHourPresent in items[keyTeacher][keyDay][keyCourse]) {
                        for (keyGroup in items[keyTeacher][keyDay][keyCourse][keyHourPresent]) {
                          var iTeach = -1;
                          var i = -1;
                          for (var item in teacherSchedule) {
                            i++;
                            if (teacherSchedule[item][0].text.teacher == 'S::' + keyTeacher) {iTeach = i}
                          }
                          if (iTeach == -1) {
                              teacherSchedule.push(self.copyArray(teacherScheduleRow));
                              iTeach = teacherSchedule.length - 1;
                              teacherSchedule[iTeach][0].text.teacher = 'S::' + keyTeacher;         // PAY ATTENTION!!! MUST BE DESIGN A BETTER SOLUTION
                          }
                          var subKey = keyCourse
                          if (subKey == 'R') {subKey = 'Ric'}
                          teacherSchedule[iTeach][self.stdTime.findIndex(findSchedule)+1].text = 
                                {'group': keyGroup, 'course': subKey, 
                                'room': items[keyTeacher][keyDay][keyCourse][keyHourPresent][keyGroup].room}
                        }
                      }
                    
                  }
                }
              }
            }
            resolve(teacherSchedule)
          });
    });
  }
  //------------------------------------------------------------------------------------------------
  // utility function, return day of week for the requsted day
  // example: 1-LUN
  //------------------------------------------------------------------------------------------------
  public  getDayKey(reqDate) {
    var d = new Date(reqDate);   
    var dayName = this.weekDays[d.getDay()-1];
    return d.getDay() + '-' + dayName;
  }
  //------------------------------------------------------------------------------------------------
  // utility function, return next day date for the requsted date
  // 
  //------------------------------------------------------------------------------------------------
  public  getAnotherDay(reqDate, val) {
    var d = new Date(reqDate); 
    var dx = d.valueOf()+val  
    return new Date(dx).toString()
  }
  //------------------------------------------------------------------------------------------------
  // utility function, return next day date for the requsted date
  // 
  //------------------------------------------------------------------------------------------------
  public  getNumDay(reqDate, endDate) {
    var d = new Date(reqDate); 
    var dx = d.valueOf() 
    var d1 = new Date(endDate); 
    var dx1 = d1.valueOf()
    return Math.trunc((dx1-dx)/(24*60*60*1000))
  }
  //------------------------------------------------------------------------------------------------
  // this function is useful to inizialize a new array by val and not by ref. 
  // Pay attention the .slice() don't work properly with obj but only for boolean, number and string
  //------------------------------------------------------------------------------------------------
  public  copyArray(o) {
      var output, v, key;
      output = Array.isArray(o) ? [] : {};
      for (key in o) {
        v = o[key];
        output[key] = (typeof v === "object") ? this.copyArray(v) : v;
      }
      return output;
  }
  //------------------------------------------------------------------------------------------------
  // this function remove from first parameter array the item key (element 0) just present in the 
  // second array, so there are no duplicate item 
  //------------------------------------------------------------------------------------------------
  private  clearDuplicate(first, second) {
    var cleared = this.copyArray(first)
    if (Object.keys(cleared).length > 0) {
      for (var item in  second) {
        for (var it in cleared) {
          if (second[item][0].text.teacher == cleared[it][0].text.teacher  && second[item][0].text.type == 'A'){ 
            var verifiedSchedule = this.clearSchedule(second[item],cleared[it])
            //console.log("Schedule cleared ...", verifiedSchedule) 
            var canBeCleared = false
            for (let i=1; i < this.stdTime.length+1; i++) {
              if (!verifiedSchedule[i]['text']['group']) {canBeCleared = true}
            }
            if (canBeCleared) {
              cleared.splice(it,1)
            } else {
              //console.log("Schedule cleared 2...", verifiedSchedule) 
              cleared[it] = verifiedSchedule
            }
          }
        }
      }
    }
    return cleared;
  }
  private clearSchedule(a,b){    // a=array ore di assenza, b= array ore da togliere se non uguale ad a, o rimuovere totlamente se == a
    for (let i=1; i < this.stdTime.length+1; i++) {
      //console.log("HH ....", i, a[i]['text']['group'], typeof(a[i]['text']['group']))
      if (typeof(a[i]['text']['group']) == 'string') { b[i]['text'] = ' '}
    }
    
    return b
  }
  //------------------------------------------------------------------------------------------------
  // little function used tu build a key of a day of week, like '1-LUN' or '2-MAR' and so on
  //------------------------------------------------------------------------------------------------
  private dayOfWeek (reqDate) {
    var d = new Date(reqDate);   
    var dayName = this.weekDays[d.getDay()-1];
    return d.getDay() + '-' + dayName;
  }
  //------------------------------------------------------------------------------------------------
  // this function finds days of week with schedule lessons, to dinamic buils selection array.
  // maybe can be more easy to save a setup parameter in future.
  //------------------------------------------------------------------------------------------------
  public readDays () {
    var path = this.dbRoot + this.pathActiveSchedule + this.pathWeekly + this.pathSite;
    return new Promise((resolve) => {
        this.days = this.db.object(path, ).snapshotChanges();
        this.days.subscribe(action => {
          var tt = [];  
          action.payload.forEach(function(childSnapshot) {
            tt.push(childSnapshot.key);
          });
        resolve(tt);
        }); 
    });
  }
  //------------------------------------------------------------------------------------------------
  // this function builds an array that will be displayed in Weekly schedule page
  //------------------------------------------------------------------------------------------------
  public readWeekly(day, table, fillRow, colorCourse, colorTeacher, colorClass) {
    var path = this.dbRoot + this.pathActiveSchedule + this.pathWeekly + this.pathSite
    return new Promise((resolve) => {
      this.item = this.db.object(path + day,).valueChanges();
      this.item.subscribe(items => {
        var keyCourse, keyTeacher, keySchedule;
        function findSched(el) {
          return el.text == keySchedule
        }  
        for (keyCourse in items) {
          var course = fillRow.slice();
          var tiles = {text: keyCourse, cols: 2, rows: 1, color: colorCourse};
          course[0] = tiles;
          for (keyTeacher in items[keyCourse]) {
            tiles = {text: keyTeacher, cols: 1, rows: 1, color: colorTeacher};
            course[1] = tiles;
            for (keySchedule in items[keyCourse][keyTeacher]) {
              course[table[0].findIndex(findSched)] = {text: items[keyCourse][keyTeacher][keySchedule].group, cols: 1, rows: 1, color: colorClass};
            }
            table.push(course);
            course = fillRow.slice();
          }
        }
        resolve();
      });
    });
  }
  //------------------------------------------------------------------------------------------------
  // this function builds an array that will be displayed in Teacher schedule page
  //------------------------------------------------------------------------------------------------
  public readTeacher(teacherType, teacher, tableInit, fillRow, colorCourse, colorDay, colorClass) {
      var pathSchedule ='';
      if (teacherType == 'C') {pathSchedule = this.pathActiveSchedule}
      if (teacherType == 'S') {pathSchedule = this.pathActiveScheduleSupport}
      var path = this.dbRoot + pathSchedule + this.pathTeachers + this.pathSite
      return new Promise((resolve) => {
        this.item = this.db.object(path + teacher, ).valueChanges();
        this.item.subscribe(items => {
          var table = [];
          var keyCourse, keyDay, keySchedule, keyGroup;
          function findSched(el) {
            return el.text == keySchedule
          }  
          for (keyCourse in items) {
            var course = fillRow.slice();
            var tiles = {text: keyCourse, cols: 1, rows: 1, color: colorCourse};
            course[0] = tiles;
            for (keyDay in items[keyCourse]) {
              tiles = {text: keyDay, cols: 2, rows: 1, color: colorDay};
              course[1] = tiles;
              for (keySchedule in items[keyCourse][keyDay]) {
                for (keyGroup in items[keyCourse][keyDay][keySchedule]) {
                  course[tableInit[0].findIndex(findSched)] = {text: keyGroup, cols: 1, rows: 1, color: colorClass}; 
                }
              }
              table.push(course);
              course = fillRow.slice();
            }
          }
          resolve(table);
        });
    });
  }
  //----------------------------------------------------------------------------------------------------------
  // this function builds an array that will be displayed in Class (called group in other part) schedule page
  //---------------------------------------------------------------------------------------------------------
  public readClass(classLabel, tableInit, fillRow, colorCourse, colorDay, colorClass) {
      var path = this.dbRoot + this.pathActiveSchedule + this.pathClasses + this.pathSite
      return new Promise((resolve) => {
        this.item = this.db.object(path + classLabel, ).valueChanges();
        this.item.subscribe(items => {
          var table = [];
          var keyDay, keySchedule, keyTeacher;
          function findSched(el) {
            return el.text == keySchedule
          }
          for (keyDay in items) {
            var course = fillRow.slice();
            var tiles = {text: keyDay, cols: 1, rows: 1, color: colorDay};
            course[0] = tiles;
            for (keySchedule in items[keyDay]) {
              for (keyTeacher in items[keyDay][keySchedule]) {
                course[tableInit[0].findIndex(findSched)] = 
                {text: keyTeacher +' - '+ items[keyDay][keySchedule][keyTeacher].subject +' - '
                + items[keyDay][keySchedule][keyTeacher].room, cols: 1, rows: 3, color: colorClass};
              }
            }
            table.push(course);
            course = fillRow.slice();
          }
        resolve(table);
        });
      });
  }
  //----------------------------------------------------------------------------------------------------------
  // this function builds an array that will be displayed in Class (called group in other part) schedule page
  //---------------------------------------------------------------------------------------------------------
  public getGroupSchedule(classLabel, reqDate) {
    
    var path = this.dbRoot + this.pathActiveSchedule + this.pathClasses + this.pathSite
    var dayKey = this.dayOfWeek(reqDate);
    return new Promise((resolve) => {
      this.item = this.db.object(path + classLabel +'/'+dayKey, ).valueChanges();
      this.item.subscribe(items => {
      var schedule = [], daySched = []
      for (var keySched in items) {
        daySched.push({'sched': keySched, group: classLabel, 'value': false, 'disabled': false})
      }
      schedule.push({"day": dayKey, "value": daySched})
      console.log("FDS --> Get group Schedule ...:",classLabel, schedule )
      resolve(schedule);
      });
    });
  }
    //----------------------------------------------------------------------------------------------------------
  // this function builds an array that will be displayed in Class (called group in other part) schedule page
  //---------------------------------------------------------------------------------------------------------
  public getClass(classLabel, reqDate) {
    console.log("Get Class ...:",classLabel )
    var path = this.dbRoot + this.pathActiveSchedule + this.pathClasses + this.pathSite
    var dayKey = this.dayOfWeek(reqDate);
    return new Promise((resolve) => {
      this.item = this.db.object(path + classLabel +'/'+dayKey, ).valueChanges();
      this.item.subscribe(items => {
        var schedule = [];
        for (var keySched in items) {
          schedule.push({'schedule': keySched, 'group': classLabel})
        }
      resolve(schedule);
      });
    });
  }
  //------------------------------------------------------------------------------------------------
  // this function find a teacher, to validate input form field
  //------------------------------------------------------------------------------------------------
  public getTeacherSchedule(teacherType, teacher, reqDate, endDate, type) {
    //console.log("FDS --> getTeacherSchedue 1..: ", reqDate, endDate, type)
    var numDay = 1
    if (type == "P") {numDay = this.getNumDay(reqDate, endDate) >= 7 ? 7 : this.getNumDay(reqDate, endDate)+1}
    var pathSchedule ='';
    if (teacherType == 'C') {pathSchedule = this.pathActiveSchedule}
    if (teacherType == 'S') {pathSchedule = this.pathActiveScheduleSupport}
    var path = this.dbRoot + pathSchedule + this.pathTeachers + this.pathSite
      //var d = new Date(reqDate);   
      //var dayName = this.weekDays[d.getDay()-1];
      
    var schedule = [];
    var res = {};
    return new Promise((resolve) => {
      this.item = this.db.object(path + teacher, ).valueChanges();
      this.item.subscribe(items => {
        //console.log("FDS --> getTeacherSchedue 2..:", dayKey, items)
        for (var d=0; d<numDay; d++ ) {
          for (var keyDay in items) {
            var dayKey = this.getDayKey(this.getAnotherDay(reqDate, d*24*60*60*1000))
            if (keyDay == dayKey) {
              var daySched = []
              if (type == 'P') {
                for (var t in this.stdTime) {
                  daySched.push({'sched': this.stdTime[t], 'group': '', 'value': false, 'disabled': false})
                }
              }
              for (var keyCourse in items[keyDay]) {
                for (var keySched in items[keyDay][keyCourse]) {
                  for (var keyGroup in items[keyDay][keyCourse][keySched]) {
                    var group = keyGroup
                    if (group == '--C--') {group = keyCourse == 'R' ? 'Ric':keyCourse}
                    var idx = daySched.findIndex(findSchedule)
                    if (idx == -1) {
                      daySched.push({'sched': keySched, 'group': group, 'value': false, 'disabled': false})
                    } else {
                      daySched[idx]['group'] = group, daySched[idx]['disabled'] = true
                    }
                  }
                }
              }
              schedule.push({"day": dayKey, "value": daySched})
            }
          }
        }
        function findSchedule(el) {
          return el['sched'] == keySched
        }
          schedule.sort(function (a, b) {
            var nameA = a['day']; 
            var nameB = b['day']; 
            if (nameA < nameB) {return -1}
            if (nameA > nameB) {return 1}
            return 0;
          });
        for (var ds in schedule) {
          schedule[ds]['value'].sort(function (a, b) {
            var nameA = a['sched']; 
            var nameB = b['sched']; 
            if (nameA < nameB) {return -1}
            if (nameA > nameB) {return 1}
            return 0;
          });
        }
        //console.log("FDS --> getTeacherSchedue 5..:", schedule) 
        if (schedule.length !== 0) {resolve(schedule)}
        else {resolve('no class')}
      });
    });
  }
  //------------------------------------------------------------------------------------------------
  // this function find a teacher, to validate input form field
  //------------------------------------------------------------------------------------------------
  public getTeacher(teacherType, teacher, reqDate) {
    //console.log("Get teacher...:", teacherType, teacher)
    var pathSchedule ='';
    if (teacherType == 'C') {pathSchedule = this.pathActiveSchedule}
    if (teacherType == 'S') {pathSchedule = this.pathActiveScheduleSupport}
    var path = this.dbRoot + pathSchedule + this.pathTeachers + this.pathSite
      //var d = new Date(reqDate);   
      //var dayName = this.weekDays[d.getDay()-1];
      var dayKey = this.getDayKey(reqDate)
    var groups = [];
    var schedule = [];
    var res = {};
    return new Promise((resolve) => {
      this.item = this.db.object(path + teacher, ).valueChanges();
      this.item.subscribe(items => {
        for (var keyDay in items) {
          if (keyDay == dayKey) {
            for (var keyCourse in items[keyDay]) {
              for (var keySched in items[keyDay][keyCourse]) {
                for (var keyGroup in items[keyDay][keyCourse][keySched]) {
                  var iGroup = -1;
                  var i = -1;
                  for (var item in groups) {
                    i++;
                    if (groups[i] == keyGroup) {iGroup = i}
                  }
                  if (iGroup == -1) {
                    groups.push(keyGroup);
                  }
                  schedule.push({'schedule': keySched, 'group': keyGroup})
                }
              }

            }
          }
        }
        if (groups.length == 0 && teacher !== '') {groups.push('No Class')}
        schedule.sort(function (a, b) {
          var nameA = a.schedule; 
          var nameB = b.schedule; 
          if (nameA < nameB) {return -1}
          if (nameA > nameB) {return 1}
          return 0;
        });
        res['groups'] = groups;
        res['schedule'] = schedule;
        resolve(res);
      });
    });
  }
  //-----------------------------------------------------------------------------------------------------
  // generic record of case, with correlate record in other order. Probably this function will be revised
  // after develop completion of case '51' on substitution.
  //----------------------------------------------------------------------------------------------------- 
  public saveCase(caseData: CaseData) {
    var path = this.dbRoot + this.pathCases;
    return new Promise((resolve, reject) => {
      var self = this
      var key = this.MAX_KEY-caseData.regDate;
     // if (caseData.caseId !== 15) {
        if (caseData.editDate == -1) {
          var promise = this.db.object(path + 'regDate/' + key).remove()
        } else {
          var promise = this.db.object(path + 'regDate/' + key).update(caseData)
        }
        promise
        .then (function(){
          if (caseData.caseType !== 'P' ) {
            return self.saveCaseEndDate(caseData);
          } else {
            return
          }
        })
        .then (function(){
          if (caseData.caseType == 'R') {
            return self.saveCaseAbsenceToRecover(caseData);
          } else {
            return
          }
        })
        .then (function(){
              resolve ();
        })
        .catch (function(err){
          reject (err);
        });
    /*  } else {
        self.deleteCaseAndCorrelate(key)
        .then (function(){
          resolve ();
        })
        .catch (function(err){
          reject (err);
        });
      } */
    });
  }
  //-----------------------------------------------------------------------------------------------------
  // denormalize CaseData: save by endDate, so it's ready to check teacher lack in a given day.
  // Manage CaseData changing throw previousEndDate, used to remove old registration before write new one
  //-----------------------------------------------------------------------------------------------------
  private saveCaseEndDate(caseData: CaseData) {
    var path = this.dbRoot + this.pathCases;
    return new Promise((resolve, reject) => {
      var self = this
      var keyNew = caseData.endDate;
      var keyOld = caseData.previousEndDate;
        var promise = this.db.object(path + 'endDate/' + keyOld +'-'+ caseData.regDate).remove()
        promise
        .then (function(){
          if (caseData.editDate !== -1) {
          return self.db.object(path + 'endDate/' + keyNew +'-'+ caseData.regDate).update(caseData);
          } else 
          { return }
        })
        .then (function(){
            resolve ();
        })
        .catch (function(err){
          reject (err);
        });
    });
  }
    //-----------------------------------------------------------------------------------------------------
  // this record is written only if the absence case must be recovered
  //-----------------------------------------------------------------------------------------------------
  private saveCaseAbsenceToRecover(caseData: CaseData) {
    var path = this.dbRoot + this.pathCases + this.pathRecovery
    return new Promise((resolve, reject) => {
      var self = this
      //var add60gg = 60*24*60*60*1000;
      var keyNew = caseData.endDate + this.add60gg;
      var keyOld = caseData.previousEndDate + this.add60gg;
        var promise = this.db.object(path + caseData.firstTeacher + '/' + keyOld +'-'+ caseData.regDate).remove()
        promise
        .then (function(){
          if (caseData.editDate !== -1) {
          return self.db.object(path + caseData.firstTeacher + '/' + keyNew +'-'+ caseData.regDate).update(caseData);
          } else 
          { return }
        })
        .then (function(){
            resolve ();
        })
        .catch (function(err){
          reject (err);
        });
    });
  }
  //------------------------------------------------------------------------------------------------
  // Save a group of records correlated one with the others.
  // Tpically used for case 15 and the one ore more case 16 linked
  //------------------------------------------------------------------------------------------------
  public saveMultipleCases(items) {
    return new Promise((resolve, reject) => {
      var path = this.dbRoot + this.pathCases;
      var promises = [];
      for (var item in items){
         promises.push(this.saveCase(items[item]))
      }
      Promise.all(promises)
      .then(res =>{
        resolve(res);
      })
      .catch(err =>{
        reject(err);
      });
    }); 
  }
  //------------------------------------------------------------------------------------------------
  // Save a group of records correlated one with the others.
  // Tpically used for case 15 and the one ore more case 16 linked
  //------------------------------------------------------------------------------------------------
  public saveAvailableAtACharge(item) {
    return new Promise((resolve, reject) => {
      var path = this.dbRoot + this.pathCases + this.pathAvailbility + this.pathSite;
      var key_new = item['teacher']+'/'+item['endDate']+'-'+item['regDate']
      var key_old = item['teacher']+'/'+item['previousEndDate']+'-'+item['regDate']
      var promises = [];
      promises.push(this.db.object(path + key_old).remove())
      if (item.editDate == -1) {
        promises.push(this.db.object(path + key_new).remove())
      } else {
        promises.push(this.db.object(path + key_new).update(item))
      }
      Promise.all(promises)
      .then(res =>{
        resolve(res);
      })
      .catch(err =>{
        reject(err);
      });
    });
  }
  //------------------------------------------------------------------------------------------------
  // Read a Case giving a key
  // 
  //------------------------------------------------------------------------------------------------ 
  public readCase(key) {
    return new Promise((resolve) => {
      var path = this.dbRoot + this.pathCases +'regDate/';
      this.item = this.db.object(path + key ).valueChanges();
      this.item.subscribe(res => {
        resolve(res);
      });
    });
  }
  //------------------------------------------------------------------------------------------------
  // Save a group of records correlated one with the others.
  // Tpically used for case 15 and the one ore more case 16 linked
  //------------------------------------------------------------------------------------------------
  public readMultipleCases(items) {
    return new Promise((resolve, reject) => {
      var promises = [];
      for (var item in items){
         promises.push(this.readCase(items[item]))
      }
      Promise.all(promises)
      .then(res =>{
        //console.log("read multiple case ...:", res)
        resolve(res);
      })
      .catch(err =>{
        reject(err);
      });
    }); 
  }   
  //------------------------------------------------------------------------------------------------
  // An important function to manage the teacher substitution, this create the appropiate record and
  // does the right update on correlate informations.
  //------------------------------------------------------------------------------------------------
  public createSubstitutionCase(items) {
    var self = this;
    var path = this.dbRoot + this.pathCases;
    var regDate = Date.now();
    var key = this.MAX_KEY-regDate;
    var dateEpoch = items[0].requestDay;
    var firstTeacher , secondTeacher, note, absenceEndDate;
    var schedule = {} ; 
    var keySched = items[0].hour;
    if (items[0].type == 'A') {firstTeacher = items[1].teacher, secondTeacher = items[0].teacher, note = items[1].type, 
        schedule[keySched]= items[0].group+', '+items[1].group;}
    else {firstTeacher = items[0].teacher, secondTeacher = items[1].teacher, note = items[0].type, 
        schedule[keySched]= items[1].group+', '+items[0].group;}
    if (items[0].type == 'R' ) {absenceEndDate = items[0].endDate}
    if (items[1].type == 'R' ) {absenceEndDate = items[1].endDate}  // must update 'absences-to-be-recovered' path
    var groupArr = schedule[keySched].split(", ")
    if (note == 'SHC') {
      note = firstTeacher.substr(3)
      firstTeacher = firstTeacher + ' (' + groupArr[0] + ')'
    } else {
      if (firstTeacher.substr(0,1) == 'S') {note = 'S'}
      if (groupArr[1] == 'Ric' || groupArr[1] == '- P -') {note = 'SP'}
      if (groupArr[1] == '--C--' || groupArr[1].substr(0,1) == 'D') {note = 'D'}
    }
    if (absenceEndDate) {
      var absence = absenceEndDate.split('-')
      console.log("Absence date...:",absence[0], dateEpoch )
      if (Number(absence[0]) - this.add60gg - dateEpoch > 0) {note = 'RA'} else {note = 'RE'}
    }
      // set condition to print group event (split, exit, ...) without change firt teacher mnagement
    const recordCaseData: CaseData = {
      caseId: 51,
      caseName: 'Sostituzione docente assente',
      caseType: 'S',
      regDate: regDate,
      editDate: regDate,
      firstTeacher: firstTeacher,
      secondTeacher: secondTeacher,
      startDate: dateEpoch,
      endDate: dateEpoch,
      previousEndDate: dateEpoch,
      settled: true,
      note: note,
      classes: {},
      regRecovery: {},
      regDateLinked: [],
      endDateLinked: [],
      absenceLinked: []
    };
    if (absenceEndDate) {
     // var dw = new Date(absenceEndDate)
      //var absenceEndDateEpoch = dw.valueOf()
      recordCaseData.absenceLinked.push(absenceEndDate)
    }
    recordCaseData.classes[keySched] = schedule[keySched];
    return new Promise((resolve, reject) => {
      this.db.object(path + 'regDate/' + key).update(recordCaseData)
      .then(res => {
        // remember to insert other update....!!!!!!!!!!!!!!!!!!!!
        return self.updateAbsence(absenceEndDate, recordCaseData, 1);
      })
      .then(res =>{
        resolve (true)
      })
        
    }); 
  }
 //-------------------------------------------------------------------------------------------------------
  // Update record teacher absence: (if op = 1) sum 1 to recovered counter and push the new reg key to regRecovery
  // array, so we are able to rebuild recovered counter, or rollback if the substitution record is deleted
  // If op = -1 do reverse operation (subtract and remove reg key from regRecovery)
  //------------------------------------------------------------------------------------------------------
  public updateAbsence(absenceEndDateEpoch, recordCaseData, op) {
    //console.log("Absence date...:", absenceEndDateEpoch, recordCaseData.regDate, op)
    var self = this;
    var path = this.dbRoot + this.pathCases + this.pathRecovery;
    return new Promise((resolve, reject) => {
      if (absenceEndDateEpoch) {
        var fullPath = path + recordCaseData.firstTeacher  +'/'+ absenceEndDateEpoch;
        //console.log("Absence path ...:", fullPath)
        this.db.object(fullPath).valueChanges() 
        .take(1)
        .subscribe(res =>{
          if (res) {
            var regRecovery = {};
            if (op == -1) {
              regRecovery[recordCaseData.regDate] = null
            } else {
              regRecovery[recordCaseData.regDate] = true
            }
            this.db.object(fullPath+'/regRecovery').update(regRecovery)
            .then(_ => {
              var regKey = (this.MAX_KEY - res['regDate']).toString()
              return this.db.object(this.dbRoot + this.pathCases + '/regDate/' + regKey +'/regRecovery').update(regRecovery)
            })
            .then(_ => {
              //console.log("Absence updated....!",res)
              resolve();
            })
            .catch(err => console.log(err, "Failed Absence update <------"));
            } else {
              resolve();
            }
        });
      } else {
        resolve();
      }
    }); 
  }

 //------------------------------------------------------------------------------------------------
  // Delete the substitution Case record and
  // does the right update and delete on correlate informations.
  //------------------------------------------------------------------------------------------------
  public deleteSubstitutionCase(items) {
    return new Promise((resolve, reject) => {
      var path = this.dbRoot + this.pathCases;
      var promises = [];
      for (var item in items){
        var key = this.MAX_KEY-Number(items[item]);
        //console.log("Try to delete. Substituion Case..:",key)
        promises.push(this.deleteCaseAndCorrelate(key))
      }
      Promise.all(promises)
      .then(res =>{
        resolve();
      })
      .catch(err =>{
        reject(err);
      });

    }); 
  }
 //------------------------------------------------------------------------------------------------
  // Delete records correlate to a Case and the Case himself
  // does the right update 
  //------------------------------------------------------------------------------------------------
  public deleteCaseAndCorrelate(key) {
    return new Promise((resolve, reject) => {
      console.log("FDS --> deleteCaseAndCorrelate key..: ", key)
      var path = this.dbRoot + this.pathCases;
      var promises = [];
      var fullPath = path +'regDate/'+ key;
      this.db.object(fullPath).valueChanges() 
      .take(1)
      .subscribe(res =>{
        var fullPathRecovery = path+this.pathRecovery+res['firstTeacher']+'/'+(res['endDate']+this.add60gg).toString()+'-'+res['regDate']
        var fullPathAvailability = path+this.pathAvailbility + this.pathSite+res['firstTeacher']+'/'+res['endDate']+'-'+res['regDate']
        for (var endDateLinked in res['endDateLinked']){
          console.log("Try to delete endDateLinked...:",res['endDateLinked'][endDateLinked])
          promises.push(this.db.object(path+'endDate/'+res['endDateLinked'][endDateLinked]).remove())
        }
        for (var regDateLinked in res['regDateLinked']){
          console.log("Try to delete regDateLinked...:",res['regDateLinked'][regDateLinked])
          promises.push(this.deleteCaseAndCorrelate(res['regDateLinked'][regDateLinked]))
        }
        for (var absenceLinked in res['absenceLinked']){
          console.log("Try to update absenceLinked...:",res['absenceLinked'][absenceLinked])
          promises.push(this.updateAbsence(res['absenceLinked'][absenceLinked], res, -1))
        }
        console.log("Try to delete Absence to Recover fullPath..:", fullPathRecovery)
        promises.push(this.db.object(fullPathRecovery).remove())
        console.log("Try to delete availability-At-A-Charge fullPath..:", fullPathAvailability)
        promises.push(this.db.object(fullPathAvailability).remove())
        promises.push(this.db.object(fullPath).remove());
        Promise.all(promises)
        .then(res =>{
          resolve();
        })
        .catch(err =>{
          reject(err);
        });
      });
    }); 
  }
  //-------------------------------------------------------
  // return an array with the scheduled teacher's replacement
  // in the given month
  //-------------------------------------------------------
  public getMontlyReplacement(reqMonth,fillRow) {
    return new Promise((resolve) => { 
      var self = this
      var path = this.dbRoot + this.pathCases;
      var dateFirst = new Date(reqMonth.substr(10,4)+'-'+reqMonth.substr(7,2)+'-'+'01');   
      var dateLast = new Date(reqMonth.substr(10,4), reqMonth.substr(7,2), 0); 
      var startAt = dateFirst.valueOf() - 3600000  // Because this date start at 01.00 hours, incredible!!!!
      var endAt = dateLast.valueOf()
      //console.log("Date first and last...:",startAt, endAt)
       var reportMatrix = [];
       var reportRow = this.copyArray(fillRow);
          self.db.list(path + 'regDate/', ref => ref.orderByChild('caseType').equalTo('S')).valueChanges()
            .subscribe(items  => {
              function findRow (el) {
                return (el[0].text == reportRow[0].text && el[1].text == reportRow[1].text &&
                        el[2].text == reportRow[2].text && el[13].text == reportRow[13].text)
              }
              for (var i in items) {
                if (items[i]['firstTeacher'] == 'C::Favaretto R') {console.log("Items ...: ", items[i])}
                if (startAt <= items[i]['startDate'] && items[i]['startDate'] <= endAt) {
                  if (items[i]['caseType'] == 'S') {
                    reportRow[0].text = items[i]['startDate'];
                    reportRow[1].text = items[i]['secondTeacher'];
                    reportRow[2].text = items[i]['firstTeacher'];
                    var schedule = this.scheduleToArray(items[i]['classes']);
                    var idx = 2;
                    for (let r in schedule) {
                      idx++
                      reportRow[idx].text = schedule[r];
                    }
                    reportRow[13].text = items[i]['note'];
                    var idxMatrix = reportMatrix.findIndex(findRow)
                    if (idxMatrix == -1) {
                      reportMatrix.push(this.copyArray(reportRow));
                    } else {
                      idx = 2
                      for (let r in schedule) {
                        idx++
                        if (schedule[r]) {reportMatrix[idxMatrix][idx].text = schedule[r]}
                      }
                    }
                  }
                }
              }
              reportMatrix.sort(function (a, b) {
                var nameA = a[0].text; 
                var nameB = b[0].text; 
                if (nameA < nameB) {return -1}
                if (nameA > nameB) {return 1}
                return 0;
              });
               resolve(reportMatrix) 
             });
       });
  }

  private scheduleToArray(items) {
    var self = this;
    var scheduleArray = [];
    scheduleArray.length = 10;
    scheduleArray = Array.from(scheduleArray, function(val, idx){return ''} );
    function findSched(el) {
      return el == keySched
    }
    for (var s in items) {
      var keySched = s
      var group = items[s].split(',');
      scheduleArray[self.stdTime.findIndex(findSched)] =  group[0]
    }
    return scheduleArray
  }

  public getMontlyCaseData (reqMonth, fillRow) {
    return new Promise((resolve) => { 
      var self = this
      var path = this.dbRoot + this.pathCases;
      var dateFirst = new Date(reqMonth.substr(10,4)+'-'+reqMonth.substr(7,2)+'-'+'01').valueOf()- 3600000;   
      var dateLast = new Date(reqMonth.substr(10,4), reqMonth.substr(7,2), 0).valueOf(); 
      var reportMatrix = [];
      var reportRow = this.copyArray(fillRow);
      //console.log("Date events..:", dateFirst, dateLast)
      //this.db.list(this.dbRoot + this.pathCases + 'regDate/', ref => ref.orderByChild().startAt(startAt.toString()).endAt(endAt.toString())).valueChanges()
      this.db.list(this.dbRoot + this.pathCases + 'regDate/', ref => ref.orderByChild('startDate').startAt(dateFirst).endAt(dateLast)).valueChanges()
      .subscribe(items  => {
        for (var i in items) {
          //console.log("Item ...:", i)
          //if (dateFirst.valueOf() <= items[i]['startDate'] && items[i]['startDate'] <= dateLast.valueOf()) {
            //var schedule = this.scheduleToArray(items[i]['classes']);
              reportRow[0].text = items[i]['startDate'];
              reportRow[1].text = items[i]['endDate'];          
              reportRow[2].text = items[i]['regDate'];
              reportRow[3].text = items[i]['caseId'] + ' ' + items[i]['caseType'];
              reportRow[4].text = items[i]['caseName'];
              reportRow[5].text = items[i]['firstTeacher'];
              reportRow[6].text = items[i]['secondTeacher'];
              reportRow[7].text = items[i]['settled'];
              reportRow[8].text = items[i]['classes'];
              reportRow[9].text = items[i]['note'];
              reportMatrix.push(this.copyArray(reportRow));
          //}
        }
        reportMatrix.sort(function (a, b) {
          var nameA = a[0].text; 
          var nameB = b[0].text; 
          if (nameA < nameB) {return -1}
          if (nameA > nameB) {return 1}
          return 0;
        });
         resolve(reportMatrix) 
      });
    });
  }

//--------------------------------------------------------------------------------------------------
// authentication hendller: for now save user every login, so eventyually custom field will be lost.
// >>>>>> Design for better use of this info will be done <<<<<<<
//--------------------------------------------------------------------------------------------------
  public login() {
    return new Promise((resolve, reject) => {
      this.afAuth.auth.signOut();
      this.afAuth.auth.signInWithPopup(new firebase.auth.GoogleAuthProvider());
        this.user.subscribe(res => {
          this.saveUser(res)
            .then(function() {
              //console.log("saved user");
                resolve ();
              })
            .catch (function(err){
                  reject (err);
            });
        });
      });
  }

  public logout() {
    this.afAuth.auth.signOut();
  }

  private saveUser(res) {
      return new Promise((resolve, reject) => {
        var key = res.uid;
        var data = {};
        data['uid'] = res.uid, data['displayName'] = res.displayName, data['email'] = res.email;
        data['emailVerified'] = res.emailVerified, data['isAnonymous'] = res.isAnonymous ;
        data['photoURL'] = res.photoURL, data['lastLogin'] = Date.now();
        const promise = this.db.object(this.dbRoot + this.pathUser + key).set(data)
        promise
        .then (function(){
          resolve ();
        })
        .catch (function(err){
          reject (err);
        });
      });
  }

  public isLogged() {
    return this.user
  }

// class closure
}



// WEBPACK FOOTER //
// c:/Dev/Angular/liceo/src/app/fire-data.service.ts